
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits/deposit",
      function () {
        return require("private-next-pages/benefits/deposit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits/deposit"])
      });
    }
  